export default __webpack_public_path__ + "static/media/lion.f8299b12.svg";